import Model from "@/api/Model";

class SetPeriodStock extends Model {
    buildUrl(request) {
        return ['stock/products', request.param,'period-stock'];
    }
};

export default new SetPeriodStock;